import {GridColDef} from '@mui/x-data-grid'

// TODO: Assignment Type / Prev. Serial / Reason will be added here once a future ticket
// extends the CSV format to include them — they don't exist in the current format yet.
const previewColumns: GridColDef[] = [
  {field: 'Patient Name', headerName: 'Patient Name', flex: 1},
  {field: 'Prescriber', headerName: 'Prescriber', flex: 1},
  {field: 'Patient DOB', headerName: 'DOB', flex: 1},
  {field: 'Device Name', headerName: 'Device', flex: 1},
  {field: 'Serial Number', headerName: 'Serial', flex: 1},
]

export default previewColumns
